(function () {
  if (window.__lpLandingLoaded) return;
  window.__lpLandingLoaded = true;

  function buyBox() {
    return document.querySelector('product-info') || document.querySelector('.product') || document.querySelector('form[action*="/cart/add"]');
  }

  // Any element with data-lp-scroll-buy scrolls to the product buy box (keeps bundle offers in play).
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-lp-scroll-buy]');
    if (!trigger) return;
    var target = buyBox();
    if (!target) return;
    event.preventDefault();
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  function init() {
    // Sticky add-to-cart bar: visible once the main buy button leaves the screen.
    var sticky = document.querySelector('[data-lp-sticky]');
    var mainButton = document.querySelector('.product-form__buttons') || document.querySelector('product-form');
    if (sticky && mainButton && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var pastIt = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', pastIt);
          sticky.setAttribute('aria-hidden', pastIt ? 'false' : 'true');
        });
      }).observe(mainButton);
    }

    // UGC videos only play while on screen.
    var videos = document.querySelectorAll('.lp-ugc__media video');
    if (videos.length && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.play().catch(function () {}); } else { entry.target.pause(); }
        });
      }, { threshold: 0.5 });
      videos.forEach(function (video) { video.muted = true; video.setAttribute('playsinline', ''); videoObserver.observe(video); });
    }

    // Delivery estimate: adds business days to today.
    document.querySelectorAll('[data-lp-delivery]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 5;
      var max = parseInt(el.getAttribute('data-max'), 10) || 8;
      function addBusinessDays(days) {
        var date = new Date();
        while (days > 0) {
          date.setDate(date.getDate() + 1);
          var day = date.getDay();
          if (day !== 0 && day !== 6) days--;
        }
        return date;
      }
      var options = { weekday: 'short', month: 'short', day: 'numeric' };
      var from = addBusinessDays(min).toLocaleDateString(undefined, options);
      var to = addBusinessDays(max).toLocaleDateString(undefined, options);
      var out = el.querySelector('[data-lp-delivery-range]');
      if (out) out.textContent = from + ' – ' + to;
    });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
